import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import RGPDValidatePhone from "./RGPDValidatePhone";
import RGPDValidateOTP from "./RGPDValidateOTP";
import RGPDViewPdf from "./RGPDViewPdf";
import RGPDSigned from "./RGPDSigned";
import { getInitLink } from "../../services/rgpdService";
import NavBar from "../Common/NavBar";
import toast from "react-hot-toast";

export const RGPDWrapper = () => {
  const { token } = useParams();
  const [step, setStep] = useState("init");
  const [maskedPhone, setMaskedPhone] = useState("");
  const [clientName, setClientName] = useState("");
  const [sessionToken, setSessionToken] = useState("");

  // 🔹 Recuperar estado salvo (para persistir após reload)
  useEffect(() => {
    const saved = localStorage.getItem(`rgpd_state_${token}`);
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (parsed?.step) {
          setStep(parsed.step);
          if (parsed.sessionToken) setSessionToken(parsed.sessionToken);
          if (parsed.clientName) setClientName(parsed.clientName);
          if (parsed.maskedPhone) setMaskedPhone(parsed.maskedPhone);
          return; // Evita refazer initLink
        }
      } catch {
        localStorage.removeItem(`rgpd_state_${token}`);
      }
    }

    // 🔹 Inicia o fluxo normal (caso não exista estado salvo)
    (async () => {
      try {
        const data = await getInitLink(token);
        setMaskedPhone(data.maskedPhone);
        setClientName(data.clientName);
        setStep("phone");
      } catch {
        setStep("error");
      }
    })();
  }, [token]);

  // 🔹 Guardar estado local sempre que step ou sessionToken muda
  useEffect(() => {
    if (step !== "init" && step !== "error") {
      localStorage.setItem(
        `rgpd_state_${token}`,
        JSON.stringify({
          token,
          step,
          sessionToken,
          clientName,
          maskedPhone,
          updatedAt: new Date().toISOString(),
        })
      );
    }
  }, [step, sessionToken, token, clientName, maskedPhone]);

  // 🔹 Limpar storage quando o processo termina (para evitar reentradas antigas)
  const clearLocalState = () => {
    localStorage.removeItem(`rgpd_state_${token}`);
  };

  // 🔹 Tratamento por etapas (mantendo UI e consistência original)
  return (
    <div>
      <NavBar />
      <div className="flex justify-center bg-[#F3F4F6] container-noNav">
        <div className="w-full sm:p-10 xs:p-6 sm:ml-5 sm:mr-5 max-w-screen-md justify-center">
          {step === "error" && (
            <div className="text-center text-red-600 font-medium">
              Link inválido ou expirado.
            </div>
          )}

          {step === "phone" && (
            <RGPDValidatePhone
              token={token}
              maskedPhone={maskedPhone}
              clientName={clientName}
              onNext={() => setStep("otp")}
            />
          )}

          {step === "otp" && (
            <RGPDValidateOTP
              token={token}
              clientName={clientName}
              onValidated={(sessionToken) => {
                setSessionToken(sessionToken);
                setStep("pdf");
              }}
              onResendOtp={() => toast.success("Novo código OTP enviado!")}
            />
          )}

          {step === "pdf" && (
            <RGPDViewPdf
              sessionToken={sessionToken}
              onSigned={() => {
                setStep("signed");
                clearLocalState(); // remove do localStorage após assinatura
              }}
            />
          )}

          {step === "signed" && (
            <RGPDSigned
              clientName={clientName}
              onFinish={() => clearLocalState()}
            />
          )}
        </div>
      </div>
    </div>
  );
};